import { render, staticRenderFns } from "./HandyMovementImport.vue?vue&type=template&id=c64fc4ce&scoped=true&"
import script from "./HandyMovementImport.vue?vue&type=script&lang=ts&"
export * from "./HandyMovementImport.vue?vue&type=script&lang=ts&"
import style0 from "./HandyMovementImport.vue?vue&type=style&index=0&id=c64fc4ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64fc4ce",
  null
  
)

export default component.exports